module.exports = __webpack_public_path__ + "static/slide6-unexpected-dd765c3289cf66367ccbeab7e4e53339.jpg";